<template>
  <section class="app-main">
    <keep-alive :max="20">
      <router-view
        v-if="$route.meta && $route.meta.keepAlive"
        :key="`${$route.name}-${pageCacheVersion($route.name)}`"
        @ContactSeller="ContactSeller"
      ></router-view>
    </keep-alive>
    <transition name="fade" mode="out-in">
      <router-view
        v-if="isMainLayoutRoute && (!$route.meta || !$route.meta.keepAlive)"
        :key="$route.name || $route.path"
        @ContactSeller="ContactSeller"
      ></router-view>
    </transition>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'AppMain',
  computed: {
    ...mapGetters([
      'pageCacheVersion'
    ]),
    isMainLayoutRoute() {
      return this.$route.matched.some(item => item.meta && item.meta.keepRootLayout)
    }
  },
  methods: {
    ContactSeller(e,nickname) {
      this.$emit('ContactSeller', e ,nickname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue